import { Box, Button, Container, Stack, Typography } from "@mui/material";
import Logo from "./sks.png";
import Modal from "./SmallModal";
import { useState } from "react";

const INFO_PAGES = [
  { id: "tietokanta", label: "Tietokanta" },
  { id: "hakuohjeet", label: "Hakuohjeet" },
  { id: "täydentäminen", label: "Täydentäminen" },
];

function Header() {
  const [showModal, setShowModal] = useState();
  const [type, setType] = useState();

  const showMore = (id) => {
    setType(id);
    setShowModal(true);
  };

  const handleClose = (e) => {
    setShowModal(false);
  };

  return (
    <Box
      component="header"
      sx={{
        bgcolor: "background.paper",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
          py: 1.5,
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <a href="https://www.genealogia.fi/" title="Suomen Sukututkimusseura">
            <Box
              component="img"
              sx={{ height: { xs: 44, sm: 52 }, display: "block" }}
              alt="Suomen sukututkimusseuran logo"
              src={Logo}
            />
          </a>
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.5rem", sm: "1.85rem" },
                lineHeight: 1.1,
              }}
            >
              Henkikirjahaku
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Suomen Sukututkimusseura
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={0.5} component="nav">
          {INFO_PAGES.map(({ id, label }) => (
            <Button
              key={id}
              color="inherit"
              onClick={() => showMore(id)}
              sx={{
                color: "text.secondary",
                "&:hover": { color: "primary.main" },
              }}
            >
              {label}
            </Button>
          ))}
        </Stack>
      </Container>
      <Modal showModal={showModal} handleClose={handleClose} type={type} />
    </Box>
  );
}

export default Header;
